import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Shared shadcn utility: consumers can override defaults without conflicting utilities. */
export function cn(...parts: ClassValue[]): string {
  return twMerge(clsx(parts));
}
